/* eslint-disable no-case-declarations */

import {
  setUpApp,
  attemptLogin,
  getCase,
  startApplicant,
  clearErrorMessage,
  checkStatus,
} from './actions';

const initialState = {
  authenticated: false,
  authError: '',
  configured: false,
  identityId: '',
  propositionID: '',
  pickableApplications: null,
  showApplicationPicker: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case 'CONFIGURED_APP':
      return {
        ...state,
        configured: true,
      };
    case 'SET_PROPOSITION_ID':
      return {
        ...state,
        propositionID: action.propositionID,
      };
    case 'SET_PICKABLE_APPLICATIONS':
      return {
        ...state,
        pickableApplications: action.swaps,
        showApplicationPicker: true,
      };
    case 'CLOSE_APPLICATION_PICKER':
      return {
        ...state,
        showApplicationPicker: false,
      };
    case 'AUTHENTICATE_SUCCESS':
      return {
        ...state,
        identityId: action.identityId,
        authenticated: true,
      };
    case 'AUTHENTICATE_FAILED':
      return {
        ...state,
        authenticated: false,
        authError: action.message,
      };
    case '@@router/LOCATION_CHANGE': {
      window.scrollTo(0, 0);
      return state;
    }
    default:
      return state;
  }
};

const caseInitialState = {
  ready: false,
  loading: false,
  error: '',
  application: null,
  currentApplicant: null,
  showMember2: false,
  showApartment2: false,
  showDetails2: false,
  isTriangle: false,
};

export const caseReducer = (state = caseInitialState, action) => {
  switch (action.type) {
    case 'FETCHING_APPLICATION':
      return { ...state, loading: true, case: null };
    case 'RECEIVED_APPLICATION':
      return {
        ...state,
        ready: true,
        loading: false,
        application: action.application,
        currentApplicant: action.currentApplicant,
      };
    case 'FETCH_APPLICATION_ERROR':
      return { ...state, error: action.error, loading: false };
    case 'CLEAR_ERROR_MESSAGE':
      return { ...state, error: '' };
    case 'SHOW_MEMBER2':
      return { ...state, showMember2: true };
    case 'HIDE_MEMBER_2':
      return { ...state, showMember2: false };
    case 'SHOW_APARTMENT2':
      return { ...state, showApartment2: true };
    case 'SHOW_DETAILS2':
      return { ...state, showDetails2: true };
    case 'SET_TRIANGLE_SWAP':
      return { ...state, isTriangle: true };
    default:
      return state;
  }
};

const statusInitialState = {
  member1: null,
  member2: null,
  apartment1: null,
  apartment2: null,
  details1: null,
  details2: null,
  swapReason: null,
  minUc: null,
  proofOfId: null,
  incomeBase: null,
  rentalAgreement: null,
  rentalBase: null,
  LBControl: null,
  sign: null,
  landlordControl: null,
  statuses: [],
};

export const statusReducer = (state = statusInitialState, action) => {
  switch (action.type) {
    case 'member1':
      return { ...state, member1: action.status };
    case 'member2':
      return { ...state, member2: action.status };
    case 'apartment1':
      return { ...state, apartment1: action.status };
    case 'apartment2':
      return { ...state, apartment2: action.status };
    case 'swapReason':
      return { ...state, swapReason: action.status };
    case 'details1':
      return { ...state, details1: action.status };
    case 'details2':
      return { ...state, details2: action.status };
    case 'MIN_UC_STATUS':
      return { ...state, minUc: action.status };
    case 'ID_PROOF_STATUS':
      return { ...state, proofOfId: action.status };
    case 'INCOME_BASE_STATUS':
      return { ...state, incomeBase: action.status };
    case 'RENTAL_BASE_STATUS':
      return { ...state, rentalBase: action.status };
    case 'RENTAL_AGREEMENT_STATUS':
      return { ...state, rentalAgreement: action.status };
    case 'LB_CONTROL_STATUS':
      return { ...state, LBControl: action.status };
    case 'SIGN_STATUS':
      return { ...state, sign: action.status };
    case 'OTHER_STATUS':
      const statuses = [...state.statuses];

      const filteredStatuses = statuses.filter(
        obj => obj.applicantId !== action.data.applicantId
      );

      filteredStatuses.push(action.data);

      return { ...state, statuses: filteredStatuses };
    default:
      return state;
  }
};

export {
  setUpApp,
  attemptLogin,
  getCase,
  startApplicant,
  clearErrorMessage,
  checkStatus,
};



// WEBPACK FOOTER //
// ./src/features/App/reducer.js